export default {
    'zh_CN': {
        'common.sys-config.id.label': '参数主键',
        'common.sys-config.id.holder': '请输入参数主键',
        
        
        'common.sys-config.id.required': '参数主键必填',
        'common.sys-config.name.label': '参数名称',
        'common.sys-config.name.holder': '请输入参数名称',
        'common.sys-config.name.max': '参数名称最多100个字符',
        
        'common.sys-config.name.required': '参数名称必填',
        'common.sys-config.sign.label': '参数键名',
        'common.sys-config.sign.holder': '请输入参数键名',
        'common.sys-config.sign.max': '参数键名最多100个字符',
        
        'common.sys-config.sign.required': '参数键名必填',
        'common.sys-config.content.label': '参数键值',
        'common.sys-config.content.holder': '请输入参数键值',
        'common.sys-config.content.max': '参数键值最多500个字符',
        
        'common.sys-config.content.required': '参数键值必填',
        'common.sys-config.type.label': '系统类型',
        'common.sys-config.type.holder': '请输入系统类型',
        
        
        'common.sys-config.type.dictionary': ()=>[{value:0,label:'系统外置'},{value:1,label:'系统内置'}],
        'common.sys-config.type.required': '系统类型必填',
        'common.sys-config.remark.label': '备注',
        'common.sys-config.remark.holder': '请输入备注',
        'common.sys-config.remark.max': '备注最多500个字符',
        
        'common.sys-config.remark.required': '备注必填',
        'common.sys-config.createTime.label': '创建时间',
        'common.sys-config.createTime.holder': '请输入创建时间',
        'common.sys-config.createTime.required': '创建时间必填',
        'common.sys-config.updateTime.label': '更新时间',
        'common.sys-config.updateTime.holder': '请输入更新时间',
        'common.sys-config.updateTime.required': '更新时间必填',
        'common.sys-config.deleted.label': '是否删除',
        'common.sys-config.deleted.holder': '请输入是否删除',
        'common.sys-config.deleted.required': '是否删除必填'
    },
    'zh_TW': {
        'common.sys-config.id.label': '参数主键',
        'common.sys-config.id.holder': '請輸入参数主键',
        
        
        'common.sys-config.id.required': '参数主键必填',
        'common.sys-config.name.label': '参数名称',
        'common.sys-config.name.holder': '請輸入参数名称',
        
        
        'common.sys-config.name.required': '参数名称必填',
        'common.sys-config.sign.label': '参数键名',
        'common.sys-config.sign.holder': '請輸入参数键名',
        
        
        'common.sys-config.sign.required': '参数键名必填',
        'common.sys-config.content.label': '参数键值',
        'common.sys-config.content.holder': '請輸入参数键值',
        
        
        'common.sys-config.content.required': '参数键值必填',
        'common.sys-config.type.label': '系统类型',
        'common.sys-config.type.holder': '請輸入系统类型',
        
        
        'common.sys-config.type.required': '系统类型必填',
        'common.sys-config.remark.label': '备注',
        'common.sys-config.remark.holder': '請輸入备注',
        
        
        'common.sys-config.remark.required': '备注必填',
        'common.sys-config.createTime.label': '创建时间',
        'common.sys-config.createTime.holder': '請輸入创建时间',
        
        
        'common.sys-config.createTime.required': '创建时间必填',
        'common.sys-config.updateTime.label': '更新时间',
        'common.sys-config.updateTime.holder': '請輸入更新时间',
        
        
        'common.sys-config.updateTime.required': '更新时间必填',
        'common.sys-config.deleted.label': '是否删除',
        'common.sys-config.deleted.holder': '請輸入是否删除',
        
        
        'common.sys-config.deleted.required': '是否删除必填'
    },
    'en_US': {
        'common.sys-config.id.label': 'id',
        'common.sys-config.id.holder': 'Enter id',
        'common.sys-config.id.max': 'id max length: 参数主键',
        
        
        'common.sys-config.id.required': 'id required',
        'common.sys-config.name.label': 'name',
        'common.sys-config.name.holder': 'Enter name',
        'common.sys-config.name.max': 'name max length: 参数名称',
        
        
        'common.sys-config.name.required': 'name required',
        'common.sys-config.sign.label': 'sign',
        'common.sys-config.sign.holder': 'Enter sign',
        'common.sys-config.sign.max': 'sign max length: 参数键名',
        
        
        'common.sys-config.sign.required': 'sign required',
        'common.sys-config.content.label': 'content',
        'common.sys-config.content.holder': 'Enter content',
        'common.sys-config.content.max': 'content max length: 参数键值',
        
        
        'common.sys-config.content.required': 'content required',
        'common.sys-config.type.label': 'type',
        'common.sys-config.type.holder': 'Enter type',
        'common.sys-config.type.max': 'type max length: 系统类型',
        
        
        'common.sys-config.type.required': 'type required',
        'common.sys-config.remark.label': 'remark',
        'common.sys-config.remark.holder': 'Enter remark',
        'common.sys-config.remark.max': 'remark max length: 备注',
        
        
        'common.sys-config.remark.required': 'remark required',
        'common.sys-config.createTime.label': 'createTime',
        'common.sys-config.createTime.holder': 'Enter createTime',
        'common.sys-config.createTime.max': 'createTime max length: 创建时间',
        
        
        'common.sys-config.createTime.required': 'createTime required',
        'common.sys-config.updateTime.label': 'updateTime',
        'common.sys-config.updateTime.holder': 'Enter updateTime',
        'common.sys-config.updateTime.max': 'updateTime max length: 更新时间',
        
        
        'common.sys-config.updateTime.required': 'updateTime required',
        'common.sys-config.deleted.label': 'deleted',
        'common.sys-config.deleted.holder': 'Enter deleted',
        'common.sys-config.deleted.max': 'deleted max length: 是否删除',
        
        
        'common.sys-config.deleted.required': 'deleted required'
    }
}
